var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterMobileSingleMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 16,
  viewBox: "0 0 18 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.487 14.667h13.026q.485 0 .811-.323.327-.324.327-.802V4.646l-6.513 4.291A2.1 2.1 0 0 1 9 9.271a2.1 2.1 0 0 1-1.138-.334L1.349 4.646v8.896q0 .479.327.802.326.323.811.323M15.513 1.333H2.487q-.464 0-.8.323a1.04 1.04 0 0 0-.338.781v.646l7.25 4.75q.38.27.801.021l7.251-4.77v-.647q0-.457-.337-.78a1.12 1.12 0 0 0-.801-.324M2.487 0h13.026a2.43 2.43 0 0 1 1.76.708q.727.709.727 1.73v11.104q0 1.02-.727 1.74a2.4 2.4 0 0 1-1.76.718H2.487q-1.032 0-1.76-.719A2.36 2.36 0 0 1 0 13.541V2.438Q0 1.417.727.708A2.43 2.43 0 0 1 2.487 0"
})));
export default SvgTwitterMobileSingleMessage;